import { Interest } from "@bullseye/types"

import { useGetRequest } from "./useRequest"

export const useUserInterests = (userId?: string) => {
  const { data, isLoading, error, refetch } = useGetRequest<{
    data: Interest[]
  }>(
    {
      method: "GET",
      path: `v1/users/${userId}/interests`,
    },
    {
      enabled: !!userId,
    },
  )

  return {
    data: data?.data,
    isLoading,
    error,
    refetch,
  }
}
